;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { resolveShareViewTourStartRoute } from "@/features/onboarding-tours/orchestrator/resolve-share-view-tour-route";
import { TOUR_OVERLAY_GROUPS } from "@/features/onboarding-tours/orchestrator/tour-overlay-groups";
import { tourStep } from "@/features/onboarding-tours/orchestrator/tour-step-builder";
import {
	TOUR_TARGETS,
	tourSelector,
} from "@/features/onboarding-tours/orchestrator/tour-target-ids";
import { defineTour } from "@/features/onboarding-tours/registry/define-tour";
import { TourCategory } from "@/features/onboarding-tours/types/tour-category";

const shareViewButtonTarget = tourSelector(TOUR_TARGETS.shareViewButton);
const shareDialogCreateTarget = tourSelector(TOUR_TARGETS.shareDialogCreate);
const shareDialogAccessTarget = tourSelector(
	TOUR_TARGETS.shareDialogAccessControl,
);
const shareDialogVisualizationsTriggerTarget = tourSelector(
	TOUR_TARGETS.shareDialogVisualizationsTrigger,
);
const shareDialogVisualizationsPanelTarget = tourSelector(
	TOUR_TARGETS.shareDialogVisualizationsPanel,
);
const shareDialogAdvancedTriggerTarget = tourSelector(
	TOUR_TARGETS.shareDialogAdvancedSettingsTrigger,
);
const shareDialogAdvancedPanelTarget = tourSelector(
	TOUR_TARGETS.shareDialogAdvancedSettingsPanel,
);
const shareDialogCreateSubmitTarget = tourSelector(
	TOUR_TARGETS.shareDialogCreateSubmit,
);

export const shareAViewTour = defineTour({
	buildSteps: () => [
		tourStep({
			content: "Open the share dialog to create a link for this dashboard.",
			data: {
				advanceOn: "target-click",
				watchTargetClick: {
					selector: shareViewButtonTarget,
					stepIndex: 1,
				},
			},
			placement: "bottom",
			target: shareViewButtonTarget,
			title: "Share this view",
			waitForTarget: true,
		}),
		tourStep({
			content: "Start a new link from the share dialog.",
			data: {
				advanceOn: "target-click",
				overlayGroup: TOUR_OVERLAY_GROUPS.shareDialog,
				watchTargetClick: {
					selector: shareDialogCreateTarget,
					stepIndex: 2,
				},
			},
			effect: "openShareDialog",
			hideOverlay: true,
			placement: "top",
			spotlightPadding: 12,
			target: shareDialogCreateTarget,
			title: "Start a share link",
			waitForTarget: true,
		}),
		tourStep({
			content:
				"Choose who can access this link — public, workspace, or restricted.",
			data: {
				advanceOn: "target-click",
				overlayGroup: TOUR_OVERLAY_GROUPS.shareDialog,
			},
			effect: "openShareCreate",
			hideOverlay: true,
			placement: "left",
			spotlightPadding: 8,
			target: shareDialogAccessTarget,
			title: "Access control",
			waitForTarget: true,
		}),
		tourStep({
			content: "Expand Visualizations and choose which charts to include.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: shareDialogVisualizationsPanelTarget,
				overlayGroup: TOUR_OVERLAY_GROUPS.shareDialog,
			},
			effect: "openShareCreate",
			hideOverlay: true,
			placement: "left",
			spotlightPadding: 8,
			target: shareDialogVisualizationsTriggerTarget,
			title: "Choose charts",
			waitForTarget: true,
		}),
		tourStep({
			content: "Set expiration, theme, and other options in Advanced Settings.",
			data: {
				advanceOn: "target-visible",
				advanceWhenTarget: shareDialogAdvancedPanelTarget,
				overlayGroup: TOUR_OVERLAY_GROUPS.shareDialog,
			},
			effect: "openShareCreate",
			hideOverlay: true,
			placement: "left",
			spotlightPadding: 8,
			target: shareDialogAdvancedTriggerTarget,
			title: "Advanced settings",
			waitForTarget: true,
		}),
		tourStep({
			content: "Create the link when you are ready to share.",
			data: {
				completeWhenTargetsClicked: [shareDialogCreateSubmitTarget],
				overlayGroup: TOUR_OVERLAY_GROUPS.shareDialog,
			},
			effect: "openShareCreate",
			hideOverlay: true,
			placement: "top",
			spotlightPadding: 8,
			target: shareDialogCreateSubmitTarget,
			title: "Create the link",
			waitForTarget: true,
		}),
	],
	catalog: {},
	category: TourCategory.sharing,
	description:
		"Create share links so stakeholders can access dashboards securely.",
	eligibility: {},
	id: "share-a-view",
	launch: {
		resolveStartRoute: ({ workspaceId, currentPathname, activeViewNames }) => {
			const resolution = resolveShareViewTourStartRoute({
				activeViewNames,
				currentPathname,
				workspaceId,
			});

			if (resolution.status === "unavailable") {
				return "unavailable";
			}

			if (resolution.status === "start-here") {
				return null;
			}

			return resolution.route;
		},
	},
	tags: ["share", "link", "dashboard", "collaboration"],
	title: "Share a view",
});
